// extracted by mini-css-extract-plugin
module.exports = {"SSignupForm":"MailchimpSignupForm_SSignupForm__YaNl_","SLabel":"MailchimpSignupForm_SLabel__ifOPX","STermsError":"MailchimpSignupForm_STermsError__0FoBz"};